'use strict';

var equipment = function () {
  var _getCategories = function _getCategories(equipArray) {
    var categories = [];
    equipArray.map(function (elem) {
      if (categories.indexOf(elem.vtipoItem) === -1) categories.push(elem.vtipoItem);
    });
    return categories;
  };

  var _manageResponse = function _manageResponse(equipArray) {
    var categories = _getCategories(equipArray),
        $categoriesContainer = $('.js-categories-container'),
        $tabInput = $('.js-category-tab-input'),
        $tabLabel = $('.js-category-tab-label'),
        $tabBlock = $('.js-category-tab-block'),
        $newTabInput = $tabInput.remove().clone(),
        $newTabLabel = $tabLabel.remove().clone(),
        $newTabBlock = $tabBlock.remove().clone();

    var _loop = function _loop(i) {
      var $targetInput = $newTabInput.clone().attr('id', 'tab-' + i);
      if (i === 0) $targetInput.attr('checked', 'checked');
      var $targetLabel = $newTabLabel.clone().attr('for', 'tab-' + i).text(categories[i]);
      var $targetBlock = $newTabBlock.clone();
      var $targetList = $targetBlock.find('.js-category-list');
      var itemsArray = equipArray.filter(function (elem) {
        return elem.vtipoItem === categories[i];
      });

      var $newItem = $targetList.find('.js-category-item').remove().clone();

      for (var _i = 0; _i < itemsArray.length; _i++) {
        var $targetItem = $newItem.clone().text(itemsArray[_i].vitem);
        $targetList.append($targetItem);
      }

      $categoriesContainer.append($targetInput, $targetLabel, $targetBlock);
    };

    for (var i = 0; i < categories.length; i++) {
      _loop(i);
    }

    $('.dtm-more-info').on('click', function () {
      dtmTag.track.toggle('more vehicle information', this.childNodes[0].textContent.trim());
    });
  };
  var _init = function _init(gradeId) {
    $.ajax({
      method: 'get',
      dataType: 'json',
      // url: `https://configurador.nissan.es/html/equipamiento.jsp?pnGrado=${gradeId}`,
      url: 'https://serviciosweb.nissan.es/pws/api/items/byVersion/' + gradeId,
      success: function success(response) {
        _manageResponse(response);
      },
      error: function error(_error) {
        console.log('error', _error);
      }
    });
  };
  return {
    init: _init
  };
}();